import React from 'react';
import { INotificationSettings } from '@bb/domain/dist/types';
import { LocationsDTO } from '@bb/domain/dist/types/dto/OrgController/locations';
import { pick } from 'lodash';
import { Divider } from 'components';
import { ListingLabelContext } from 'contexts';

import BasicCard from '../BasicCard';
import BranchFilter from './BranchFilter';
import DailyRecaps from './DailyRecaps';
import FridayUpdate from './FridayUpdate';
import InstantUpdates from './InstantUpdates';
import ListingTypeFilter from './ListingTypeFilter';
import UnsubscribeAll from './UnsubscribeAll';

type NotificationsCardProps = {
  notifications: INotificationSettings;
  locations: LocationsDTO['locations'];
  setModifiedNotifications: React.Dispatch<
    React.SetStateAction<INotificationSettings>
  >;
};

const NotificationsCard: React.FC<NotificationsCardProps> = ({
  notifications,
  locations,
  setModifiedNotifications,
}) => {
  const { isHidden } = React.useContext(ListingLabelContext);
  const { disabled_locations, weeklyUpdate } = notifications;

  return (
    <BasicCard title="Notifications">
      <BranchFilter
        locations={locations}
        disabledLocations={disabled_locations}
        setModifiedNotifications={setModifiedNotifications}
      />
      <Divider />
      <ListingTypeFilter
        listingTypes={notifications.types}
        setModifiedNotifications={setModifiedNotifications}
      />
      <InstantUpdates
        prefixComponent={<Divider />}
        instantNotifications={notifications.instant}
        setModifiedNotifications={setModifiedNotifications}
      />
      <Divider />
      <DailyRecaps
        dailySettings={pick(
          notifications,
          'dailyOpenHouse',
          'dailyNewListings',
          'dailyNeeds',
        )}
        setModifiedNotifications={setModifiedNotifications}
      />
      {!isHidden('COMING_SOON') && (
        <>
          <Divider />
          <FridayUpdate
            weeklyUpdate={weeklyUpdate}
            setModifiedNotifications={setModifiedNotifications}
          />
        </>
      )}

      <Divider />
      <UnsubscribeAll
        notifications={notifications}
        setModifiedNotifications={setModifiedNotifications}
      />
    </BasicCard>
  );
};

export default NotificationsCard;
